/** Dropdown options for additional services (excludes product-linked services). */
export function computeFilteredServicesForDropdown(allServices, rfqServicesData = []) {
  const list = Array.isArray(allServices) ? allServices : []
  const rfq = Array.isArray(rfqServicesData) ? rfqServicesData : []
  if (!rfq.length) return list
  return list.filter(
    (service) =>
      !rfq.some(
        (selected) =>
          Number(selected.labour_cost_service_id) === Number(service.id),
      ),
  )
}

export async function fetchLabourCostServicesForDropdown(axios, REST_API, options = {}) {
  const { isNotSplitOrder = true } = options
  const productsRes = await axios.post(`${REST_API}webservice/request/get-products`, {
    isNotSplitOrder,
    noProduct: true,
    noMaterial: true,
  })
  return productsRes?.data?.labourCostServices || []
}
